import React from "react";
import { Link } from "react-router-dom";
import { Typography, Card, CardContent, CardMedia } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import {
  demoThumbnailUrl,
  demoVideoUrl,
  demoVideoTitle,
  demoChannelUrl,
  demoChannelTitle,
} from "../utils/constants";

const VideoCard = ({ video, snippet, color }) => (
  <Card
    sx={{
      width: { xs: "100%", sm: "358px", md: "320px" },
      boxShadow: "none",
      borderRadius: 5,
    }}
  >
    <Link
      to={video?.videoId ? `/video/${video.videoId}` : `/video/cV2gBU6hKfY`}
    >
      <CardMedia
        image={video?.thumbnails[0]?.url || demoThumbnailUrl}
        alt={snippet?.title}
        sx={{ width: { xs: "100%", sm: "358px" }, height: 180 }}
      />
    </Link>
    <CardContent sx={{ backgroundColor: color?"white": "#1E1E1E", height: "116px" }}>
      <Link to={video?.videoId ? `/video/${video?.videoId}` : demoVideoUrl}>
        <Typography variant="subtitle1" fontWeight="bold" color= {color?'#000':"#dadada"}>
          {video?.title.slice(0, 60) || demoVideoTitle.slice(0, 60)}
        </Typography>
      </Link>
      <Link
        to={`/channel/${video?.author?.channelId}`}
      >
          <CardMedia
            image={video.author.avatar[0]?.url}
            alt={video?.title}
            sx={{
              borderRadius: "50%",
              height: "38px",
              width: "38px",
              mb: 2,
              border: "1px solid #e3e3e3",
            }}
          />
          <Typography variant="subtitle2" color="gray">
            {video?.author.title || demoChannelTitle}
            <CheckCircleIcon
              sx={{
                fontSize: "12px",
                color:
                  video?.author?.badges[0]?.type === "VERIFIED_CHANNEL"
                    ? "green"
                    : "gray",
                ml: "5px",
              }}
            />
           {" "}{ video?.stats?.views}{" "}{'Views'}
          </Typography>
      </Link>
    </CardContent>
  </Card>
);

export default VideoCard;
